import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AssignmentItemEditor.html?raw';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
import ResourcePicker from '../../../moreCore/UI/ResourcePicker/ResourcePicker';


interface AssignmentDataItem extends ResourcePicker.ResourceEntry {
    identification?: string;
    ref_freight_forwarders?: {
        ID: string;
        Classname: string;
        displayname: string;
    }
}
 

class AssignmentItemEditor extends compose(_WidgetBaseSP) {

    templateString: any = template;

    inputFreightForwarder: MdsLax<InstanceType<typeof SearchSelect>>;
    inputIdentification: MdsLax<InstanceType<typeof Edit>>;
    item: AssignmentDataItem;
    itemLabel: HTMLDivElement;

    private loadFreightForwarders(): void {

        this.inputFreightForwarder.StandbyStart();

        var url = window.appRoot + "TransportIntermodal/GetFreightForwarders";

        let data = {

        };
        let stringData = JSON.stringify(data);

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onLoadFreightForwardersResponse),
            lang.hitch(this, this._onLoadFreightForwardersError),
            false // sync
        );
    }

    private _onLoadFreightForwardersResponse(response) {
        this.inputFreightForwarder.StandbyStop();
        this.inputFreightForwarder.setSelectionListLEGACY(response);
    }

    private _onLoadFreightForwardersError(error) {
        this.inputFreightForwarder.StandbyStop();
    }

    private _setData() {
        this.UiModder.domAttr.set(this.itemLabel, "innerHTML", this.item.secondaryLabel);

        this.inputIdentification.setValue(this.item.identification, true);
        this.inputFreightForwarder.setValue(this.item.ref_freight_forwarders, true)
    }

    private _onChange_Indentification() {
        this.item.identification = this.inputIdentification.getValue();

        this.emit("change", this.item);
    }
    private _onChange_FreightForwarder() {
        this.item.ref_freight_forwarders = this.inputFreightForwarder.getValue(true);
        this.emit("change", this.item);
    }
    // --------------------own methods ----------------------------end

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.loadFreightForwarders();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this._setData();

    }
}

export default mdsWidget(AssignmentItemEditor);